import { Link } from "@/i18n/navigation";

const PricingAddAgentMobile = () => {
  return (
    <div
      className={
        "mt-[56px] rounded-lg border border-primary px-[26px] py-[32px] sm:mt-[64px] sm:py-[38px] lg:mt-[136px] lg:px-[38px]"
      }
    >
      <div className={"text-title1 font-[600] text-primary sm:text-heading2"}>
        AI 에이전트를 지금 추가할 수 있습니다.
      </div>
      <div
        className={
          "mt-[16px] text-body2 text-gray-400 sm:mt-0 sm:mt-[24px] sm:text-title2"
        }
      >
        로그인 후 새로운 AI 에이전트를 바로 생성해보세요.{" "}
      </div>
      <div
        className={
          "mt-[16px] flex w-full flex-wrap-reverse items-end justify-between gap-[24px] sm:flex-nowrap sm:gap-0 lg:mt-[52px]"
        }
      >
        <div>
          <div className={"flex items-center gap-[4px]"}>
            <svg
              width="29"
              height="20"
              viewBox="0 0 29 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.15 12.5C6.757 12.5 0 14.1714 0 17.5V20H20.3V17.5C20.3 14.1714 13.543 12.5 10.15 12.5ZM3.393 17.1429C4.611 16.3143 7.5545 15.3571 10.15 15.3571C12.7455 15.3571 15.689 16.3143 16.907 17.1429H3.393ZM10.15 10C12.9485 10 15.225 7.75714 15.225 5C15.225 2.24286 12.9485 0 10.15 0C7.3515 0 5.075 2.24286 5.075 5C5.075 7.75714 7.3515 10 10.15 10ZM10.15 2.85714C11.3535 2.85714 12.325 3.81429 12.325 5C12.325 6.18571 11.3535 7.14286 10.15 7.14286C8.9465 7.14286 7.975 6.18571 7.975 5C7.975 3.81429 8.9465 2.85714 10.15 2.85714ZM20.358 12.5857C22.04 13.7857 23.2 15.3857 23.2 17.5V20H29V17.5C29 14.6143 23.925 12.9714 20.358 12.5857ZM18.85 10C21.6485 10 23.925 7.75714 23.925 5C23.925 2.24286 21.6485 0 18.85 0C18.067 0 17.342 0.185714 16.675 0.5C17.5885 1.77143 18.125 3.32857 18.125 5C18.125 6.67143 17.5885 8.22857 16.675 9.5C17.342 9.81428 18.067 10 18.85 10Z"
                fill="#009EFF"
              />
            </svg>
            <span className={"text-primary sm:text-title1 sm:font-[600]"}>
              이런 분들께 추천드려요!
            </span>
          </div>
          <div className={"mt-[16px] sm:mt-[8px]"}>
            <div className={"flex items-start gap-[8px]"}>
              <svg
                className={"mt-[4px] h-auto w-[10px] sm:h-auto sm:w-[20px]"}
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_954_1850)">
                  <path
                    d="M14.9982 5.83516L13.8232 4.66016L8.53984 9.94349L9.71484 11.1185L14.9982 5.83516ZM18.5315 4.66016L9.71484 13.4768L6.23151 10.0018L5.05651 11.1768L9.71484 15.8352L19.7148 5.83516L18.5315 4.66016ZM0.339844 11.1768L4.99818 15.8352L6.17318 14.6602L1.52318 10.0018L0.339844 11.1768Z"
                    fill="#009EFF"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_954_1850">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <span className={"text-caption2 text-black sm:text-body1"}>
                실제로 더 많은 AI 를 운영해보고 싶은 기업{" "}
              </span>
            </div>
            <div className={"mt-[8px] flex items-start gap-[8px] sm:mt-0"}>
              <svg
                className={"mt-[4px] h-auto w-[10px] sm:h-auto sm:w-[20px]"}
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_954_1850)">
                  <path
                    d="M14.9982 5.83516L13.8232 4.66016L8.53984 9.94349L9.71484 11.1185L14.9982 5.83516ZM18.5315 4.66016L9.71484 13.4768L6.23151 10.0018L5.05651 11.1768L9.71484 15.8352L19.7148 5.83516L18.5315 4.66016ZM0.339844 11.1768L4.99818 15.8352L6.17318 14.6602L1.52318 10.0018L0.339844 11.1768Z"
                    fill="#009EFF"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_954_1850">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <span className={"text-caption2 text-black sm:text-body1"}>
                서비스별, 업무별 맞춤형 AI 를 운영하고 싶은 기업{" "}
              </span>
            </div>
            <div className={"mt-[8px] flex items-start gap-[8px] sm:mt-0"}>
              <svg
                className={"mt-[4px] h-auto w-[10px] sm:h-auto sm:w-[20px]"}
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_954_1850)">
                  <path
                    d="M14.9982 5.83516L13.8232 4.66016L8.53984 9.94349L9.71484 11.1185L14.9982 5.83516ZM18.5315 4.66016L9.71484 13.4768L6.23151 10.0018L5.05651 11.1768L9.71484 15.8352L19.7148 5.83516L18.5315 4.66016ZM0.339844 11.1768L4.99818 15.8352L6.17318 14.6602L1.52318 10.0018L0.339844 11.1768Z"
                    fill="#009EFF"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_954_1850">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <span className={"text-caption2 text-black sm:text-body1"}>
                로그인만 하면 확장 운영이 가능한 유료 요금제 이용 기업{" "}
              </span>
            </div>
          </div>
        </div>
        <div className={"w-full sm:w-fit"}>
          <div className={"flex w-full items-center justify-center"}>
            <Link
              href={"/auth/sign-in"}
              className={
                "flex h-[53px] w-[232px] items-center justify-center gap-[4px] rounded-md bg-primary text-white"
              }
            >
              <span className={"text-title2 font-[600]"}>로그인 하기</span>
              <svg
                width="12"
                height="16"
                viewBox="0 0 12 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 14.12L7.417 8L0 1.88L2.2834 0L12 8L2.2834 16L0 14.12Z"
                  fill="white"
                />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingAddAgentMobile;
